import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "elder-wand",
  name: `The Elder Wand`,
  origin: "Harry Potter and the Deathly Hallows",

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
